const Ajax = require('common/infra/ajax');

class API {
    getRecentChanges(kind, options) {
        const offset = options && options.offset;
        const limit = options && options.limit;
        return Ajax.GET(`/api/my/recent-changes?kind=${kind}&offset=${offset}&limit=${limit}`);
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./common/infra/api/recent-change.js